import { Plus } from "lucide-react";

const ITEMS = [
  "Structured Medication Reviews",
  "Medicines Optimisation",
  "Opioid Reduction Programmes",
  "Care Home Reviews",
  "Prescribing Audits",
  "Clinical Pharmacists",
  "Pharmacy Technicians",
];

const COLORS = ["#10B981", "#06B6D4", "#F59E0B", "#EF4444"];

const Strip = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((item, i) => (
      <span key={item} className="flex items-center shrink-0">
        <span className="font-display text-2xl sm:text-3xl font-bold text-[#0B192C] tracking-tight px-6 sm:px-8 whitespace-nowrap">
          {item}
        </span>
        <Plus size={22} strokeWidth={3} style={{ color: COLORS[i % COLORS.length] }} />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="services-marquee"
    className="relative overflow-hidden border-y border-[#E2E8F0] bg-gradient-to-r from-white via-[#10B981]/[0.05] to-white py-5 select-none"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Strip />
      <Strip />
    </div>
  </div>
);

export default Marquee;
